<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GJZzTL/tc-custom/9781649217042.jpg?1700850014128" alt="This image is the cover for the book Battle Digest: New Orleans, Battle Digest"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battle Digest: New Orleans, Battle Digest
      </h1>
      <p class="bookDescription body article font2">
        <b>Get facts, maps, historical significance, strategies, and more in this concise summary of Andrew Jackson’s, and America’s, War of 1812 triumph.</b><br/><br/>The War of 1812 was not going particularly well for the United States. The British were blockading America’s coasts, damaging commerce, and thwarting any hopes for U.S. territorial gains in Canada. After two years of fighting, Americans were further humiliated when, in August of 1814, the British burned the U.S. Capitol. The people in the young republic yearned for respect. Brevet Major General Andrew Jackson would finally give them what they wanted with his lopsided victory at New Orleans. The victory was significant enough for the U.S. to earn the respect of Britain, which never again treated America as anything less than an independent power. It would also launch the political career of a future president.<br/><br/>Learn how Andrew Jackson’s unique leadership propelled a ragtag American army to victory against great odds, while overconfidence and coordination errors contributed to British defeat.<br/><br/>The Battle Digest summary includes all the key aspects of the campaign and battle, including maps, images, and lessons learned.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher J. Petty, Christopher Miskimon
      </h2>
      
      <p class="authorDescription body article">Christopher J. Petty is a retired Army Brigadier General, a graduate of West Point, and the U.S. Army War College. His career spanned multiple commands, including combat operations during the Iraq "Surge" and a NATO command in Bosnia. Chris's unique blend of three decades of military experience, love of history, and a passion for understanding the timeless lessons of war, make Battle Digest a unique, time-saving, and powerful resource.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Beatie
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ec7c388